import { Injectable } from '@angular/core';
import { HisBackendService } from 'hisng';
import { Observable } from 'rxjs';
import { ProjectDueDateSeries } from '../../model/project/project-due-date-series';

@Injectable()
export class ProjectDueDateService {
    constructor( private backendService: HisBackendService ) { }

    getProjectDueDateSeriesById( id: number ): Observable<ProjectDueDateSeries> {
        return this.backendService.getData( `api/v1/fs/res/project/dueDateSeries/${id}` );
    }

    getProjectDueDateSeriesByProjectId( projectLid: number ): Observable<ProjectDueDateSeries[]> {
        return this.backendService.getData( `api/v1/fs/res/project/dueDateSeriesForProject/${projectLid}` );
    }

    saveProjectDueDateSeries(projectDueDateSeries: ProjectDueDateSeries): Observable<ProjectDueDateSeries> {
        if (projectDueDateSeries.id) {
            return this.backendService.putData(`api/v1/fs/res/project/dueDateSeries/${projectDueDateSeries.id}`, projectDueDateSeries);
        } else {
            return this.backendService.postData('api/v1/fs/res/project/dueDateSeries', projectDueDateSeries);
        }
    }

    canDeleteProjectDueDateSeries(id: number) {
        return this.backendService.getData(`api/v1/fs/res/project/dueDateSeries/canDelete/${id}`);
    }

    deleteProjectDueDateSeries(id: number) {
        return this.backendService.delete(`api/v1/fs/res/project/dueDateSeries/${id}`);
    }

    calculateIndividualDueDates(projectDueDateSeries: ProjectDueDateSeries) {
        return this.backendService.putData('api/v1/fs/res/project/dueDateSeries/calculate', projectDueDateSeries);
    }
}
